import { FETCH_SAKINLER_SUCCESS } from "../actions/sakinlerAction";

const initState = {
    sakinler: [],
    pagination: null,
};

const sakinlerReducer = (state = initState, action) => {
    if (action.type === FETCH_SAKINLER_SUCCESS) {
        return {
            ...state,
            sakinler: action.payload.sakinler || action.payload, // Backward compatibility
            pagination: action.payload.pagination || null,
        };
    }

    return state;
};

export default sakinlerReducer;
